import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import { SiteSchema } from './components/SiteSchema';
import { ScrollManager } from './components/ScrollManager';
import { DgptHeader } from './components/dgpt/DgptHeader';
import { DgptFooter } from './components/dgpt/DgptFooter';
import { Home } from './pages/Home';
import { SampleMemo } from './pages/SampleMemo';
import { About } from './pages/About';
import { ToolsDirectory } from './pages/ToolsDirectory';
import { ToolPage } from './pages/ToolPage';
import { NotFound } from './pages/NotFound';
type AppProps = {
  /**
   * Design preview only: show sample usage counts (labelled "Illustrative count")
   * on tools without a verified count. Must stay false in production.
   */
  showIllustrativeCounts?: boolean;
};
export function App({
  showIllustrativeCounts = false
}: AppProps) {
  return <ThemeProvider attribute="class" defaultTheme="light" enableSystem data-id="element-0" data-mp="23w4e5zrtp20b">
      <BrowserRouter data-id="element-1" data-mp="3ijxsgzk2wgo4">
        <ScrollManager data-id="element-2" data-mp="3ikr0s4yore8d" />
        <SiteSchema data-id="element-3" data-mp="3ij61y35c994p" />
        {/* Top padding reserves space for the fixed header (h-16 / lg:h-[72px]). */}
        <div className="min-h-screen w-full bg-ink pt-16 font-sans text-text-primary antialiased lg:pt-[72px]" data-id="element-4" data-mp="3mjztd6hzp62c">
          <DgptHeader data-id="element-5" data-mp="3recf5n6xuth9" />
          <Routes data-id="element-6" data-mp="5yhupa6n3cr">
            <Route path="/" element={<Home data-id="element-8" data-mp="4n53zyrel9i" />} data-id="element-7" data-mp="6hpnd64cbd2" />
            <Route path="/sample-memo" element={<SampleMemo data-id="element-10" data-mp="2zld0746gb58w" />} data-id="element-9" data-mp="56lhc8rh1lf" />
            <Route path="/about" element={<About data-id="element-12" data-mp="2zmwguvw0rib7" />} data-id="element-11" data-mp="2zm4wkh7vh708" />
            <Route path="/tools" element={<ToolsDirectory data-id="element-14" data-mp="33lwxq8uxsavk" />} data-id="element-13" data-mp="33mouhn09senf" />
            <Route path="/tools/:slug" element={<ToolPage showIllustrativeCounts={showIllustrativeCounts} data-id="element-16" data-mp="38lrp0dimj2h5" />} data-id="element-15" data-mp="33n6xr3lcnt4u" />
            <Route path="*" element={<NotFound data-id="element-18" data-mp="3dkuu1xylt8p4" />} data-id="element-17" data-mp="38kgocmkh6au9" />
          </Routes>
          <DgptFooter data-id="element-19" data-mp="3dlntedv8gvx8" />
        </div>
      </BrowserRouter>
    </ThemeProvider>;
}